import styled from 'styled-components';

const BoldComponent = styled.b``;
export const BoldEditable = BoldComponent;
export const BoldRenderer = BoldComponent;
